define('lib/fileuploader/single',['require','underscore','jquery','lib/fileuploader/base','lib/Podio.Transport','lib/Podio.Routes'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var FileUploaderBase = require('lib/fileuploader/base');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  var defaultOptions = {
    multipleFiles: false,
    previewImageSize : 'medium',
    skin : 'single-file'
  };

  function onRemoveFileClick(options, e) {
    $(e.target).parents('.podio-uploader-file').remove();

    if(!this.elmList.children().length) {
      var file = {
        file_id: 'default',
        id: 'default'
      };

      if(options.defaultImage) {
        var elmDefaultImage = $(this.templates.item({ file: file,  enableDelete: false, style: 'default' }));

        if(options.defaultImage == 'icon') {
          elmDefaultImage.append('<div class="' + options.defaultImageIcon + '"></div>');
        }  else {
          elmDefaultImage.append(this.templates.previewImage({ file: file, url: options.defaultImage }));
        }

        elmDefaultImage.appendTo(this.elmList);
      } else {
        this.elmErrorContainer.empty().addClass('hidden');
        this.elmList.addClass('empty');
      }

    }

    this.updateFormValue();
    this.refresh();

    this.signals.onFileRemoved.dispatch();

    return false;
  }


  function render(elmTarget, options) {

    options = options ? _.defaults(options, defaultOptions) : defaultOptions;

    options.elmListContainer = elmTarget.find('.upload-attachment');
    options.elmHiddenInput = elmTarget.find('input[type=hidden]');
    options.defaultImage = options.elmListContainer.data('default-image');
    options.defaultImageIcon = options.elmListContainer.data('default-image-icon');

    var uploader = new FileUploaderBase(elmTarget, options);

    uploader.signals.onBeforeFileAdded.add(function(file) {
      uploader.clearAll();
    });

    // Remove basic functionality inherited from Base
    uploader.signals.onFileUploaded.removeAll();

    uploader.signals.onFileUploaded.add(function(file) {
      uploader.elmList.removeClass('empty');

      var elmPendingFile = uploader.elmList.find('li[data-id=' + file.id + ']');
      var elmUploadedFile = $(uploader.templates.item({ file: file, enableDelete: true, style: 'done' }));

      elmPendingFile.replaceWith(elmUploadedFile);

      uploader.updateFormValue();

      var req = transport.getJSON(routes.url_file_path(file.fileId), {
        requestData: {
          'size' : options.previewImageSize
        }
      });

      req.done(function(responseData) {
        var resolvedFile = responseData.data.file;

        if(resolvedFile.thumbnail_link) {
          elmUploadedFile.append(uploader.templates.previewImage({ file: resolvedFile }));
        } else {
          elmUploadedFile.append(uploader.templates.previewIcon({ file: resolvedFile }));
        }
      });

    });

    uploader.signals.onPostInit.add(function() {
      uploader.elmList.delegate('.podio-uploader-file .remove', 'click', _.bind(onRemoveFileClick, uploader, options));
    });

    uploader.init();

    return uploader;
  }

  return {
    render: render
  };

});


